import { PortalMultiFactor } from './portal-multifactor';

export enum enumStatus {
  'Accept' = 1,
  'Reject',
  'Transfer to Suspense Account'
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace enumStatus {
  export function values() {
    return Object.keys(enumStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  } 
}

export function statusToArray(): object[] {
  return Object.keys(enumStatus)
    .filter(key => typeof enumStatus[key] === 'number')
    .map(key => ({ id: enumStatus[key], itemName: key }));
}

// export function statusToArray(): Object[] {
//   return Object.keys(enumStatus)
//     .filter((key) => typeof (enumAuthType as any)[key] === 'number')
//     .map((key) => ({ id: (enumAuthType as any)[key], itemName: key }));
// }

export enum enumAuthType {
  Secureman = 'Secureman',
  Auth0 = 'Auth0',
  AuthServer = 'AuthServer'
}

export namespace enumAuthType {
  export function values() {
    return Object.keys(enumAuthType).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

// export function authTypeToArray(): Object[] {
//   return Object.keys(enumAuthType)
//     .filter(key => typeof enumAuthType[key] === 'string')
//     .map(key => ({ id: enumAuthType[key], itemName: key }));
// }

export function authTypeToArray(): object[] {
  return Object.keys(enumAuthType)
    .filter((key) => typeof (enumAuthType as any)[key] === 'string')
    .map((key) => ({ id: (enumAuthType as any)[key], itemName: key }));
}

export interface PortalRegister {
  id: number;
  name: string;
  icon: string;
  smtpServer: string;
  status: enumStatus;
  termsConditions: string;
  requireTermsConditions: boolean;
  displayName: string;
  displayLocation: string;
  otpExpiryDays: number;
  otpExpirySeconds: number;
  authType: enumAuthType;
  callbackURL: string;
  portalGlobalID: string;
  portalMultiFactors: PortalMultiFactor[];
  requireAuthedDevice: boolean;
  vapidPrivateKey: string;
  vapidPublicKey: string;
}

// Property Auth0ApplicationID As Auth0.Application;
